import { render, staticRenderFns } from "./gridTable.vue?vue&type=template&id=524605dc&"
import script from "./gridTable.vue?vue&type=script&lang=js&"
export * from "./gridTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports